// import * as echarts from 'echarts'
// // import { BarChart, LineChart, PieChart, RadarChart, MapChart } from 'echarts/charts'
// import Vue from 'vue'

// import {
//   TitleComponent,
//   TooltipComponent,
//   GridComponent,
//   DatasetComponent,
//   TransformComponent
// } from 'echarts/components'
// // 标签自动布局、全局过渡动画等特性
// import { LabelLayout, UniversalTransition } from 'echarts/features'
// // 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
// import { CanvasRenderer, SVGRenderer } from 'echarts/renderers'

// // 注册必须的组件
// echarts.use([
//   TitleComponent,
//   TooltipComponent,
//   GridComponent,
//   DatasetComponent,
//   TransformComponent,
//   BarChart,
//   LineChart,
//   PieChart,
//   MapChart,
//   RadarChart,
//   LabelLayout,
//   UniversalTransition,
//   CanvasRenderer,
//   SVGRenderer
// ])
import Vue from 'vue'
import * as echarts from 'echarts/lib/echarts'

// 按需引入图表组件
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/map'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/radar'
import 'echarts/lib/chart/gauge'

import 'echarts/lib/component/grid'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/dataset'
import 'echarts/lib/component/transform'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/polar'

import { DataZoomComponent } from 'echarts/components'
import { GraphChart, EffectScatterChart } from 'echarts/charts'
echarts.use([DataZoomComponent, GraphChart, EffectScatterChart])

Vue.prototype.$echarts = echarts
